import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloTestReplaceKey } from '@api/sdk.gen';
import { KubesoloHostResult, KubesoloTest } from '@api/types.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { queryKeys } from './queryKeys';

/** Pins the key the machine presents now, then re-tests it. */
export function useReplaceKeyMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      testId,
      hostId,
      fingerprint,
    }: {
      testId: KubesoloTest['id'];
      hostId: KubesoloHostResult['id'];
      fingerprint: string;
    }) =>
      kubesoloTestReplaceKey({
        path: { id: testId, hostID: hostId },
        body: { fingerprint },
      }),
    ...withInvalidate(queryClient, [queryKeys.active()]),
    ...withError('Unable to replace the host key'),
  });
}
